import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class LayoutService {

    constructor(private http: HttpClient) { }

    getLogisticsSettings(): Observable<any> {
        return this.http.get(environment.apiUrl + '/api/v1/logistics/settings');
    }
}
